module.exports = __webpack_public_path__ + "static/media/star-prata.18b5d71a.webp";